import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersShippedContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.SHIPPED]} />;
}

export default OrdersShippedContainer;
